import SelectField from 'features/forms/components/SelectField'
import styled from 'styled-components'
import { colors } from 'utils'

export const BackButton = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
    color: ${colors.icon};
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
        filter: brightness(50%);
    }
    & > span {
        margin-left: -5px;
        transform: rotate(90deg);
    }
`

export const GroupedSelectField = styled(SelectField)`
    & .react-select__option {
        padding: 4px 12px;
    }
    & .react-select__option--is-disabled {
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        color: ${colors.iconOpacity(0.5)};
        border-top: 1px solid ${colors.inputBorder};
        margin-top: 8px;
        background-color: transparent !important;
    }
    & .react-select__option--is-disabled:first-child {
        border-top: none;
    }
`
